module.exports = __webpack_public_path__ + "static/media/confirm-privacy-policy-selected.256bb3f1.svg";